import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=9f0c2370&scoped=true&"
import script from "./Permissions.vue?vue&type=script&lang=js&"
export * from "./Permissions.vue?vue&type=script&lang=js&"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=9f0c2370&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0c2370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f0c2370')) {
      api.createRecord('9f0c2370', component.options)
    } else {
      api.reload('9f0c2370', component.options)
    }
    module.hot.accept("./Permissions.vue?vue&type=template&id=9f0c2370&scoped=true&", function () {
      api.rerender('9f0c2370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/dashboard/practice-info/Permissions.vue"
export default component.exports